import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import * as moment from "moment";

import BOText from "app/components/BOComponents/BOText/BOText";

import Dialog from "material-ui/Dialog";

import { groupAuth } from "app/utils/authGroups";

class Details extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      payserv: false,
      data: null,
      modalFR: false,
      modalLog: false,
    };

    this.loadData = this.loadData.bind(this);

    // MODAL
    this.modalOpen = this.modalOpen.bind(this);
    this.modalClose = this.modalClose.bind(this);
  }

  componentDidMount() {
    this.setState({
      payserv: groupAuth.hasAccessGroup(["Payserv/Admin", "Payserv/Staff"]),
    });

    this.loadData();
  }

  loadData() {
    this.props.data.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ data: fetchMoreResult.payments[0] });
        let time = moment(fetchMoreResult.payments[0].created_at);
        let weekTest = moment()
          .subtract(7, "days")
          .startOf("day")
          .isAfter(time);

        this.props.setHeader({
          title: "Ops > Payment",
          description: `${
            weekTest
              ? moment(fetchMoreResult.payments[0].created_at).calendar()
              : moment(fetchMoreResult.payments[0].created_at).fromNow()
          } - ${fetchMoreResult.payments[0].merchant.name}`,
        });
      },
    });
  }

  modalOpen(modal: any) {
    this.setState({ [modal]: true });
  }

  modalClose(modal: any) {
    this.setState({ [modal]: false });
  }

  render() {
    const payment = this.state.data ? this.state.data : {};

    const pretifyJson = (logData) => {
      if (Object.keys(payment).length > 0) {
        const convertedData = () => {
          var data = JSON.parse(logData);
          return JSON.stringify(data, undefined, 4);
        };
        return (
          <pre
            style={{
              padding: "5px",
              margin: "5px",
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              fontSize: "12px",
            }}
          >
            {convertedData()}
          </pre>
        );
      } else {
        return null;
      }
    };

    // Format Date
    const formatDate = (date) => {
      let DateObj = new Date(date);
      let formatFullDate = `${DateObj.getFullYear()}-${(
        "0" + (parseInt(DateObj.getMonth().toString(), 10) + 1).toString()
      ).slice(-2)}-${("0" + DateObj.getDate()).slice(-2)} ${(
        "0" + DateObj.getHours()
      ).slice(-2)}:${("0" + DateObj.getMinutes()).slice(-2)}:${(
        "0" + DateObj.getSeconds()
      ).slice(-2)}`;
      return <span>{formatFullDate}</span>;
    };

    //  STATUS FORMATING
    const formatStatusColour = (status) => {
      if (status === "completed") {
        return "#ebffeb";
      } else if (status === "pending") {
        return "white";
      } else if (status === "error") {
        return "#ffebeb";
      } else {
        return "white";
      }
    };

    //  SECURE 3D
    const formatSecure3D = (status3D) => {
      if (status3D) {
        return <i className="fa fa-lock fa-lg" style={{ color: "green" }} />;
      } else {
        return <i className="fa fa-minus fa-lg" style={{ color: "red" }} />;
      }
    };

    // Summary
    const Summary = () => {
      if (payment && Object.keys(payment).length > 0) {
        return (
          <tbody>
            <tr style={{ backgroundColor: formatStatusColour(payment.status) }}>
              <td> {formatDate(payment.created_at)} </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/users/${payment.device.user.external_reference}/payments`}
                >
                  {payment.device.user.email}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.device.user.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/merchants/${payment.merchant.id}/payments`}
                >
                  {payment.merchant.name}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.merchant.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/devices/${payment.device.external_reference}/summary`}
                >
                  {payment.device.phone_number}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.device.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/payments/${payment.reference}/summary`}
                >
                  {payment.payment_strategy}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>{formatSecure3D(payment.secure3d_requested)}</td>
            </tr>
          </tbody>
        );
      } else {
        return null;
      }
    };

    // AMOUNT
    const Amount = () => {
      if (payment && Object.keys(payment).length > 0) {
        return (
          <tbody>
            <tr>
              <td style={{ padding: "5px" }}>
                {" "}
                R{(parseInt(payment.charge_amount, 10) / 100).toFixed(2)}{" "}
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R{(parseInt(payment.fee_amount, 10) / 100).toFixed(2)}{" "}
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R{(parseInt(payment.tip_amount, 10) / 100).toFixed(2)}{" "}
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R
                {payment.refund_amount
                  ? (parseInt(payment.refund_amount, 10) / 100).toFixed(2)
                  : "0.00"}{" "}
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R{(parseInt(payment.settle_amount, 10) / 100).toFixed(2)}{" "}
              </td>
            </tr>
          </tbody>
        );
      } else {
        return null;
      }
    };

    // SUBPAYMENTS
    const SubPayments = () => {
      let subpayments = payment.payserv_payment?.subpayments_json ?? "[]";
      subpayments = JSON.parse(subpayments);
      if (subpayments?.length > 0) {
        const subpayment_rows = subpayments.map((subpayment) => {
          return (
            <tr>
              <td style={{ padding: "5px" }}>{subpayment.psp}</td>
              <td style={{ padding: "5px" }}>
                {" "}
                R
                {subpayment.reserve_amount
                  ? (parseInt(subpayment.reserve_amount, 10) / 100).toFixed(2)
                  : "0.00"}{" "}
              </td>
              <td style={{ padding: "5px" }}>{subpayment.psp_reference}</td>
              <td style={{ padding: "5px" }}>{subpayment.recon_identifier}</td>
              <td style={{ padding: "5px" }}>
                {subpayment.retrieval_reference_number}
              </td>
              <td style={{ padding: "5px" }}>{subpayment.message}</td>
            </tr>
          );
        });
        return <tbody>{subpayment_rows}</tbody>;
      } else {
        return null;
      }
    };

    // MODALS
    const ModalFR = () => {
      if (payment) {
        return (
          <Dialog
            title="Filtered requests"
            modal={false}
            open={this.state.modalFR}
            onRequestClose={() => this.modalClose("modalFR")}
            actions={[
              <input
                type="button"
                className="button"
                value="Close"
                onClick={() => this.modalClose("modalFR")}
              />,
            ]}
            autoScrollBodyContent={true}
          >
            {pretifyJson(payment.filtered_request)}
          </Dialog>
        );
      } else {
        return null;
      }
    };

    const ModalLog = () => {
      if (payment) {
        return (
          <Dialog
            title="Log"
            modal={false}
            open={this.state.modalLog}
            onRequestClose={() => this.modalClose("modalLog")}
            actions={[
              <input
                type="button"
                className="button"
                value="Close"
                onClick={() => this.modalClose("modalLog")}
              />,
            ]}
            autoScrollBodyContent={true}
          >
            <pre
              style={{
                outline: "1px solid #ccc",
                padding: "5px",
                margin: "5px",
                whiteSpace: "pre-wrap",
                fontSize: "12px",
              }}
            >
              {payment.log}
            </pre>
          </Dialog>
        );
      } else {
        return null;
      }
    };

    return (
      <section>
        <div className="DetailTopBar">
          <BOText
            text="Summary"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/summary`}
            active="selected"
          />
          <BOText
            text="Details"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/details`}
            active="selected"
          />
          <BOText
            text="Pay"
            tag="span"
            class={`BODetailItem ${this.state.payserv ? "show" : "hidden"}`}
            link={`/snapscan/ops/payments/${this.props.match.params.id}/pay`}
            active="selected"
          />
          <BOText
            text="Pay requests"
            tag="span"
            class={`BODetailItem ${this.state.payserv ? "show" : "hidden"}`}
            link={`/snapscan/ops/payments/${this.props.match.params.id}/pay_requests`}
            active="selected"
          />
        </div>

        <section className="padded">
          <div
            style={{
              height: "calc(100vh - 120px)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              className="BOTable"
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  <th>
                    <b style={{ color: "#555" }}>Date</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>User</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Merchant</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Device</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Payment</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>3DS</b>
                  </th>
                </tr>
              </thead>
              {Summary()}
            </table>

            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              cellPadding={0}
              cellSpacing={0}
            >
              <tbody>
                <tr>
                  <td colSpan={4}>
                    <h3
                      style={{
                        borderBottom: "1px solid rgb(204, 204, 204)",
                        fontWeight: 400,
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: "10px",
                      }}
                    >
                      <span style={{ flex: 1 }}>Payment</span>
                      <button
                        className="button"
                        onClick={() => this.modalOpen("modalFR")}
                      >
                        Filtered request
                      </button>
                      <button
                        className="button"
                        onClick={() => this.modalOpen("modalLog")}
                      >
                        Log
                      </button>
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "5px", paddingLeft: 0 }}>
                    <b style={{ fontWeight: 400 }}>Message:</b>
                  </td>
                  <td style={{ padding: "5px" }}> {payment.message} </td>
                  <td style={{ padding: "5px" }}>
                    <b style={{ fontWeight: 400 }}>Authorization code:</b>
                  </td>
                  <td style={{ padding: "5px" }}>
                    {" "}
                    {payment.authorization_code}{" "}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "5px", paddingLeft: 0 }}>
                    <b style={{ fontWeight: 400 }}>PSP:</b>
                  </td>
                  <td style={{ padding: "5px" }}> {payment.psp} </td>
                  <td style={{ padding: "5px" }}>
                    <b style={{ fontWeight: 400 }}>Payment strategy:</b>
                  </td>
                  <td style={{ padding: "5px" }}>
                    {" "}
                    {payment.payment_strategy}{" "}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "5px", paddingLeft: 0 }}>
                    <b style={{ fontWeight: 400 }}>Type:</b>
                  </td>
                  <td style={{ padding: "5px" }}> {payment.type} </td>
                  <td style={{ padding: "5px" }}>
                    <b style={{ fontWeight: 400 }}>Secure 3D requested:</b>
                  </td>
                  <td style={{ padding: "5px" }}>
                    {" "}
                    {formatSecure3D(payment.secure3d_requested)}{" "}
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              cellPadding={0}
              cellSpacing={0}
            >
              <tbody>
                <tr>
                  <td colSpan={4}>
                    <h3
                      style={{
                        borderBottom: "1px solid rgb(204, 204, 204)",
                        fontWeight: 400,
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: "10px",
                      }}
                    >
                      Reference
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "5px", paddingLeft: 0 }}>
                    <b style={{ fontWeight: 400 }}>Reference:</b>
                  </td>
                  <td style={{ padding: "5px" }}> {payment.reference} </td>
                  <td style={{ padding: "5px" }}>
                    <b style={{ fontWeight: 400 }}>Payment token:</b>
                  </td>
                  <td style={{ padding: "5px" }}> {payment.payment_token} </td>
                </tr>
                <tr>
                  <td style={{ padding: "5px", paddingLeft: 0 }}>
                    <b style={{ fontWeight: 400 }}>PSP reference:</b>
                  </td>
                  <td style={{ padding: "5px" }}> {payment.psp_reference} </td>
                  <td style={{ padding: "5px" }}>
                    <b style={{ fontWeight: 400 }}>SnapCode:</b>
                  </td>
                  <td style={{ padding: "5px" }}> {payment.snap_code} </td>
                </tr>
                <tr>
                  <td style={{ padding: "5px", paddingLeft: 0 }}>
                    <b style={{ fontWeight: 400 }}>User reference:</b>
                  </td>
                  <td style={{ padding: "5px" }}> {payment.user_reference} </td>
                  <td style={{ padding: "5px" }}>
                    <b style={{ fontWeight: 400 }}>Scanpay session:</b>
                  </td>
                  <td style={{ padding: "5px" }}>
                    {" "}
                    {payment.scanpay_session}{" "}
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              className="BOTable"
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  <td colSpan={5}>
                    <h3
                      style={{
                        borderBottom: "1px solid rgb(204, 204, 204)",
                        fontWeight: 400,
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: "10px",
                      }}
                    >
                      Amount
                    </h3>
                  </td>
                </tr>
                <tr>
                  <th>
                    <b style={{ color: "#555" }}>Charge</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Fee</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Tip</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Refund</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Settle</b>
                  </th>
                </tr>
              </thead>
              {Amount()}
            </table>

            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              className="BOTable"
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  <td colSpan={5}>
                    <h3
                      style={{
                        borderBottom: "1px solid rgb(204, 204, 204)",
                        fontWeight: 400,
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: "10px",
                      }}
                    >
                      SubPayments
                    </h3>
                  </td>
                </tr>
                <tr>
                  <th>
                    <b style={{ color: "#555" }}>PSP</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Reserve Amount</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>PSP Reference</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Recon ID</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Markoff ID</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Status</b>
                  </th>
                </tr>
              </thead>
              {SubPayments()}
            </table>
          </div>
        </section>

        {ModalLog()}
        {ModalFR()}
      </section>
    );
  }
}

const Currentlist = gql`
  query Currentlist($reference: String) {
    payments(reference: $reference) {
      created_at
      merchant {
        name
        id
        snapmin_url
      }
      device {
        created_at
        phone_number
        snapmin_url
        external_reference
        user {
          email
          external_reference
          snapmin_url
        }
      }
      status
      log
      filtered_request
      message
      authorization_code
      psp
      payment_strategy
      snapmin_url
      type
      secure3d_requested
      reference
      payment_token
      psp_reference
      snap_code
      user_reference
      scanpay_session
      charge_amount
      fee_amount
      tip_amount
      refund_amount
      settle_amount
      rate
      payserv_payment {
        subpayments_json
      }
    }
  }
`;

const paymentDetailsWithGraphql = graphql(Currentlist, {
  options(props: any) {
    return {
      variables: {
        reference: props.match.params.id,
      },
      errorPolicy: "all",
    };
  },
})(Details);
export default paymentDetailsWithGraphql;
